import React from 'react';

import { CenteredContainerCompiled } from './presentationalComponents.tsx';
import { useTaskRowsContext } from './TaskRowsContext.tsx';

interface HeightAdjustedContainerProps {
	taskId: string;
	children: React.ReactNode;
	className?: string;
}

// Adjusts height according to description column.
export const HeightAdjustedContainer = ({
	taskId,
	children,
	className,
	...otherProps
}: HeightAdjustedContainerProps) => {
	const { taskRows } = useTaskRowsContext();
	const height = `${taskRows?.[taskId]?.rowHeight || 0}px`;

	return (
		<CenteredContainerCompiled
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={className}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
			style={{ height }}
			data-testid="height-adjusted-container"
			{...otherProps}
		>
			{children}
		</CenteredContainerCompiled>
	);
};
